import { LoginLogo } from '../components/LoginLogo';
import { LoginAlert } from '../features/Login/components';
import { LoginForm } from '../features/Login';
import { FullScreenBackground, RightSpacer } from '../styles/LoginContainerStyle';

export function Login() {
  return (
    <>
      <LoginAlert />
      <FullScreenBackground>
        {/* left space */}
        <LoginLogo />

        {/* right space */}
        <RightSpacer>
          <img src="/images/icon_basic.png" alt="ProPlus" style={{ height: 40 }} />
          <LoginForm />
        </RightSpacer>
      </FullScreenBackground>
    </>
  );
}
